import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
// import { path } from "d3";
import HrHeadPMS from "@/pages/pms/AsHr/HrHeadPMS";

const Myself = React.lazy(() => import("@/pages/pms/employee/Myself"));
const AddForm = React.lazy(() => import("@/pages/pms/employee/AddForm"));
const EditForm = React.lazy(() => import("@/pages/pms/employee/EditForm"));
const ViewForm = React.lazy(() => import("@/pages/pms/employee/ViewForm"));
const PmsPageEmbed = React.lazy(() => import("@/pages/pms/common/index"));
const AsHR = React.lazy(() => import("@/pages/pms/AsHr/Index"));
const QualityCheck = React.lazy(() => import("@/pages/pms/QualityCheck/Index"));
const OCRCheck = React.lazy(() => import("@/pages/pms/OCRCheck/Index"));
const DivisionHead = React.lazy(() => import("@/pages/pms/divisionHead/Index"));
const BusinessHead = React.lazy(() => import("@/pages/pms/businessHead/Index"));
const ReportingManager = React.lazy(
  () => import("@/pages/pms/reportingManager/Index"),
);
const Reviewer = React.lazy(() => import("@/pages/pms/reviewer/Index"));
const LTipReport = React.lazy(() => import("@/pages/pms/LTIPReport/Index"));
const LtipReportNew = React.lazy(
  () => import("@/pages/pms/LTIPReport/LtipReport"),
);
const BudgetReport = React.lazy(() => import("@/pages/pms/budgetReport/Index"));
const ORGLevelReview = React.lazy(
  () => import("@/pages/pms/ORGLevelReview/Index"),
);
const AnalyticsReport = React.lazy(
  () => import("@/pages/pms/AnalyticsReport/Index"),
);
const BudgetMaster = React.lazy(
  () => import("@/pages/pms/budgetMaster/BudgetMaster"),
);
const EmployeeLtip = React.lazy(() => import("@/pages/pms/EmployeeLtip/Index"));
const LevelDateMaster = React.lazy(
  () => import("@/pages/pms/levelDateMaster/Index"),
);
const PromotionMaster = React.lazy(
  () => import("@/pages/pms/promotionMaster/Index"),
);
const RatingMaster = React.lazy(() => import("@/pages/pms/ratingMaster/Index"));
const EligibleMaster = React.lazy(
  () => import("@/pages/pms/eligibleMaster/Index"),
);
//PMSASHR
const AsHrTab = React.lazy(() => import("@/pages/pms/CommonTab/AsHRTabs"));
const BHTabs = React.lazy(() => import("@/pages/pms/CommonTab/BHTabs"));
const PmsMaster = React.lazy(() => import("@/pages/pms/master/PmsMaster"));
const HrHradBusinessHead = React.lazy(
  () => import("@/pages/pms/businessHead/HrHeadBusinessHead"),
);
const DHnew = React.lazy(() => import("@/pages/pms/divisionHead/NewDh"));
const BHnew = React.lazy(
  () => import("@/pages/pms/businessHead/NewBusinessHead"),
);
const DivisionHeadPMS = React.lazy(
  () => import("@/pages/pms/common/DivisionHeadPMS"),
);
const BusinessHeadPMS = React.lazy(
  () => import("@/pages/pms/common/BusinessHeadPMS"),
);
const HRHeadPMS = React.lazy(() => import("@/pages/pms/common/HRHeadPMS"));
const HRPMS = React.lazy(() => import("@/pages/pms/AsHr/HRNew"));
const PayrollStatus = React.lazy(
  () => import("@/pages/pms/AsHr/PayrollStatus"),
);
const RevisedCTCSplitups = React.lazy(() => import("@/pages/pms/AsHr/QCTabs"));
const NewQC = React.lazy(() => import("@/pages/pms/QualityCheck/NewQc"));
const NewORG = React.lazy(() => import("@/pages/pms/ORGLevelReview/NewORG"));
const Manpower = React.lazy(() => import("@/pages/pms/AsHr/Manpower"));
const Conversion = React.lazy(() => import("@/pages/pms/AsHr/ConversionList"));

const Performance = [
  {
    path: "performance",
    element: (
      <SuspenseWrapper>
        <Myself />
      </SuspenseWrapper>
    ),
  },
  {
    path: "addPerformace",
    element: (
      <SuspenseWrapper>
        <AddForm />
      </SuspenseWrapper>
    ),
  },
  {
    path: "editPerformace",
    element: (
      <SuspenseWrapper>
        <EditForm />
      </SuspenseWrapper>
    ),
  },
  {
    path: "viewPerformace",
    element: (
      <SuspenseWrapper>
        <ViewForm />
      </SuspenseWrapper>
    ),
  },
  {
    path: "asHR",
    element: (
      <SuspenseWrapper>
        <AsHR />
      </SuspenseWrapper>
    ),
  },
  {
    path: "AnalyticsReport",
    element: (
      <SuspenseWrapper>
        <AnalyticsReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "DHMaster",
    element: (
      <SuspenseWrapper>
        <BudgetMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "BudgetReport",
    element: (
      <SuspenseWrapper>
        <BudgetReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ltipReport",
    element: (
      <SuspenseWrapper>
        <LTipReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "OrgLevelReview",
    element: (
      <SuspenseWrapper>
        <ORGLevelReview />
      </SuspenseWrapper>
    ),
  },
  {
    path: "qualityCheck",
    element: (
      <SuspenseWrapper>
        <QualityCheck />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ocrCheck",
    element: (
      <SuspenseWrapper>
        <OCRCheck />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pmsDivisionHead",
    element: (
      <SuspenseWrapper>
        <DivisionHead />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pmsReportingManager",
    element: (
      <SuspenseWrapper>
        <ReportingManager />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pmsReviewer",
    element: (
      <SuspenseWrapper>
        <Reviewer />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pmsBusinessHead",
    element: (
      <SuspenseWrapper>
        <BusinessHead />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pmsLtip",
    element: (
      <SuspenseWrapper>
        <EmployeeLtip />
      </SuspenseWrapper>
    ),
  },
  {
    path: "levelDateMaster",
    element: (
      <SuspenseWrapper>
        <LevelDateMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "promotionMaster",
    element: (
      <SuspenseWrapper>
        <PromotionMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "ratingMaster",
    element: (
      <SuspenseWrapper>
        <RatingMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "eligibleMaster",
    element: (
      <SuspenseWrapper>
        <EligibleMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "pmsmaster",
    element: (
      <SuspenseWrapper>
        <PmsMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "bhpms",
    element: (
      <SuspenseWrapper>
        <HrHradBusinessHead />
      </SuspenseWrapper>
    ),
  },
  {
    path: "hrpms",
    element: (
      <SuspenseWrapper>
        <HrHeadPMS />
      </SuspenseWrapper>
    ),
  },
  {
    path: "divisionheadpms",
    element: (
      <SuspenseWrapper>
        <DHnew />
      </SuspenseWrapper>
    ),
  },
  {
    path: "businessHeadPms",
    element: (
      <SuspenseWrapper>
        <BHnew />
      </SuspenseWrapper>
    ),
  },
  {
    path: "divisionheadpmsnew",
    element: (
      <SuspenseWrapper>
        <DivisionHeadPMS />
      </SuspenseWrapper>
    ),
  },
  {
    path: "businessheadpms",
    element: (
      <SuspenseWrapper>
        <BusinessHeadPMS />
      </SuspenseWrapper>
    ),
  },
  {
    path: "qualityCheckPms",
    element: (
      <SuspenseWrapper>
        <NewQC />
      </SuspenseWrapper>
    ),
  },
  {
    path: "hrheadpms",
    element: (
      <SuspenseWrapper>
        <HRHeadPMS />
      </SuspenseWrapper>
    ),
  },

  {
    path: "HRpmsnew",
    element: (
      <SuspenseWrapper>
        <HRPMS />
      </SuspenseWrapper>
    ),
  },
  {
    path: "revisedctcsplitups",
    element: (
      <SuspenseWrapper>
        <RevisedCTCSplitups />
      </SuspenseWrapper>
    ),
  },
  {
    path: "payrollstatus",
    element: (
      <SuspenseWrapper>
        <PayrollStatus />
      </SuspenseWrapper>
    ),
  },
  {
    path: "orgnew",
    element: (
      <SuspenseWrapper>
        <NewORG />
      </SuspenseWrapper>
    ),
  },
  {
    path: "manpower",
    element: (
      <SuspenseWrapper>
        <Manpower />
      </SuspenseWrapper>
    ),
  },

  {
    path: "conversion",
    element: (
      <SuspenseWrapper>
        <Conversion />
      </SuspenseWrapper>
    ),
  },
  {
    path: "LtipReportNew",
    element: (
      <SuspenseWrapper>
        <LtipReportNew />
      </SuspenseWrapper>
    ),
  },
];

export default Performance;
